<template>
  <div>
   <v-container>
      <v-row>
        <v-col cols="12">
          <h1>Import</h1>
          <p>
            {{ importFormatInfo }}
          </p>
        </v-col>
        <v-col cols="12">
          <v-autocomplete
            rounded
            filled
            label="Import format"
            v-model="importModel"
            :items="importFormats"
          ></v-autocomplete>
        </v-col>
        <div :class="{ 'body-2 url-status' : true, 'grey' : !iframeUrl, 'red' : !validateInput, 'success' : validateInput }">
          {{ !validateInput ? `Not a valid ${importModel}` : `Valid ${importModel}!`}}
        </div>

        <v-col v-show="importModel === 'Url'" cols="12">
          <v-text-field
            label="Paste your url here"
            placeholder="https://checkout.paymentiq.io/cashier/develop/?environment=test..."
            v-model="iframeUrl"
          ></v-text-field>
        </v-col>

        <v-col v-show="importModel !== 'Url'" cols="12">
          <prism-editor
            class="css-editor"
            @change="updateCode"
            :code="importCode"
            language="js"
          ></prism-editor>
        </v-col>

        <v-col cols="12">
          <v-btn @click="setNewConfigs" :disabled="!validateInput" outlined rounded class="theme-main-color">
            Update cashier!
          </v-btn>
        </v-col>
      </v-row>
   </v-container>

   <v-dialog v-model="cashierUpdated" max-width="300">
     <v-card class="success lighten-3">
       <v-layout justify-center>
          <div class="title secondary-color px-4 py-4">
            Cashier was updated!
          </div>
       </v-layout>
       <v-card-actions>
         <v-btn @click="cashierUpdated = false" block outlined>OK!</v-btn>
       </v-card-actions>
     </v-card>
   </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { initialTheme, getParams, checkIfJson } from '@/utils/helpers'
import { initialConfig } from '@/utils/initialConfig'
import PrismEditor from 'vue-prism-editor'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

export default {
  name: 'Import',
  components: {
    PrismEditor
  },
  data: () => ({
    importCode: 'Paste code here',
    iframeUrl: null,
    cashierUpdated: false,
    importModel: 'Url',
    importFormats: [
      'Url',
      'JSON'
    ]
  }),
  computed: {
    ...mapState({
      presets: ({ config }) => config.allPresets
    }),
    validateInput () {
      const { importCode } = this
      const codeIsNotDefault = importCode !== 'Paste code here'
      switch (this.importModel) {
        case 'Url':
          const { iframeUrl } = this
          if (!iframeUrl) return false
          const urlContainsBaseUrl = iframeUrl.includes('https://checkout.paymentiq.io/cashier/')
          return urlContainsBaseUrl
        case 'JSON':
        default:
          const isJson = checkIfJson(importCode)
          return codeIsNotDefault && importCode.length > 10 && isJson
      }
    },
    importFormatInfo () {
      switch (this.importModel) {
        case 'Url':
          return 'Import a cashier URL to build it here on the config page.'
        case 'JSON':
        default:
          return 'Import your configs as JSON to build it here on the config page'
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPresetName',
      'setPresets'
    ]),
    ...mapActions([
      'overrwriteConfigs',
      'overwriteTheme'
    ]),
    updateCode (code) {
      this.importCode = code
    },
    setNewConfigs () {
      const importModel = this.importModel
      if (importModel === 'Url') {
        this.setNewConfigsFromUrl()
      } else if (importModel === 'JSON') {
        this.setNewConfigsFromJSON()
      }
    },
    setNewConfigsFromJSON () {
      let configs = {
        containerHeight: '85vh',
        containerWidth: '500px'
      }
      let themes = {}
      const objectToImport = JSON.parse(this.importCode)
      if (objectToImport.hasOwnProperty('theme')) {
        themes = { ...objectToImport.theme }
        delete objectToImport.theme
      }
      for (let i in objectToImport) {
        configs[i] = objectToImport[i]
      }
      this.setImportedPreset(configs, themes)
    },
    setNewConfigsFromUrl () {
      const { iframeUrl } = this
      const urlParams = getParams(iframeUrl)
      const newConfigs = {
        ...initialConfig()
      }
      const newThemeConfigs = {
        ...initialTheme()
      }
      for (let prop in urlParams) {
        if (prop.includes('theme')) {
          const propName = prop.split('_')
          newThemeConfigs[propName[1]] = { ...newThemeConfigs[propName[1]], [propName[2]]: urlParams[prop] }
        } else {
          newConfigs[prop] = urlParams[prop]
        }
      }
      this.setImportedPreset(newConfigs, newThemeConfigs)
    },
    setImportedPreset (newConfigs, newThemeConfigs) {
      this.overrwriteConfigs(newConfigs)
      this.overwriteTheme(newThemeConfigs)
      this.cashierUpdated = true
      this.iframeUrl = null
      this.setImportPreset({ newConfigs, newThemeConfigs })
    },
    setImportPreset ({ newConfigs, newThemeConfigs }) {
      const ImportedPreset = {
        config: newConfigs,
        theme: newThemeConfigs,
        name: 'ImportedPreset',
        label: 'ImportedPreset',
        style: null
      }
      const newPresets = {
        ...this.presets,
        ImportedPreset
      }
      this.setPresets(newPresets)
      this.setPresetName('ImportedPreset')
    }
  }
}
</script>

<style lang="scss" scoped>
.url-status {
  padding: 5px 8px;
  color: white;
  border-radius: 15px;
  margin: 10px;
}
</style>
